import {
  type OnChangeFn,
  type SortingState,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import type { UserWithMeta } from '~/@biz_account/useUser/types'
import { PAGE_SIZE } from '~/@mid_query/utils/pagination.utils'
import type { ProjectsItem } from '../_project_types/project.types'
import { columns, hiddenColumns } from './columns'

export type ProjectsTableMeta = {
  userMeta?: UserWithMeta['meta']
  investorWallet?: UserWithMeta['wallets'][number]
  hasFeeImmunity?: boolean
  formatFeeSaving?: (yieldValue: number) => string | undefined
}

type RunningProjectsSorting = {
  sorting: SortingState
  onSortingChange: OnChangeFn<SortingState>
}

function useRunningProjectsTable(
  data: ProjectsItem[],
  { sorting, onSortingChange }: RunningProjectsSorting,
  tableMeta: ProjectsTableMeta
) {
  return useReactTable({
    data,
    columns,
    meta: tableMeta,
    initialState: {
      pagination: { pageSize: PAGE_SIZE },
      columnVisibility: hiddenColumns.reduce<Record<string, boolean>>(
        (acc, hiddenColumn) => {
          acc[hiddenColumn.id as string] = false
          return acc
        },
        {}
      ),
    },
    state: { sorting },
    onSortingChange,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })
}

export { useRunningProjectsTable }
